import ParcelexApi from '../../services/parcelex';
import Logger from '../../lib/logger';

export default {
  namespaced: true,
  state: {
    proposal: null,
    selectedDownPaymentOptions: null,
  },
  actions: {
    async getProposal({ commit }, { proposal }) {
      try {
        const { data } = await ParcelexApi.get(`/proposal/user/${proposal}`);
        commit('setProposalData', data);
      } catch (err) {
        Logger.error(err);
        throw new Error(err);
      }
    },
    setDownPaymentOption({ commit }, downPaymentOption) {
      commit('setDownPaymentOption', downPaymentOption);
    },
  },
  mutations: {
    setProposalData(state, data) {
      state.proposal = data.proposal;
    },
    setDownPaymentOption(state, downPaymentOption) {
      state.selectedDownPaymentOption = downPaymentOption;
    },
  },
};
